<template>
  <v-flex xs12>
    <div class="text-xs-center">
      <v-tooltip left>
        <v-btn-toggle slot="activator" mandatory class="elevation-8" @click.native="onClick">
          <v-btn flat :class="orderBy === 'alpha' && 'btn--active'" style="border: none;" @click="orderBy = 'alpha'">
            <span v-show="!superSmall" v-t="'dishesContainer.alphabetical'" />
            <v-icon>sort_by_alpha</v-icon>
          </v-btn>
          <v-btn
            v-if="!hidePrice"
            flat
            :class="orderBy === 'price' && 'btn--active'"
            style="border: none;"
            @click="orderBy = 'price'"
          >
            <span v-show="!superSmall" v-t="'dishesContainer.price'" />
            <v-icon>euro_symbol</v-icon>
          </v-btn>
          <v-btn flat :class="orderBy === 'pop' && 'btn--active'" style="border: none;" @click="orderBy = 'pop'">
            <span v-show="!superSmall" v-t="'dishesContainer.popularity'" />
            <v-icon>contacts</v-icon>
          </v-btn>
        </v-btn-toggle>
        <span v-t="'dishesContainer.orderBy'" />
      </v-tooltip>
    </div>
  </v-flex>
</template>

<script>
import StorageService from '@/services/StorageService';

export default {
  name: 'DishesSorting',
  props: {
    hidePrice: Boolean,
  },
  data() {
    return {
      orderBy: StorageService.get('dishesOrderBy') || 'alpha',
    };
  },
  computed: {
    superSmall() {
      return this.$vuetify.breakpoint.width < 350;
    },
  },
  mounted() {
    let orderBy = StorageService.get('dishesOrderBy');
    if (!orderBy) {
      StorageService.add('dishesOrderBy', 'alpha');
      orderBy = StorageService.get('dishesOrderBy');
    }
    this.$emit('orderingChange', orderBy);
  },
  methods: {
    onClick() {
      StorageService.add('dishesOrderBy', this.orderBy);
      this.$emit('orderingChange', this.orderBy);
    },
  },
};
</script>
